// Arabic
export const arLocale = {
   lang: 'ar',
   data: {
      TRANSLATOR: {
         SELECT: 'اختر لغتك',
      },
      MENU: {
         NEW: 'جديد',
         ACTIONS: 'إجراءات',
         CREATE_POST: 'إنشاء منشور جديد',
         PAGES: 'الصفحات',
         FEATURES: 'المميزات',
         APPS: 'التطبيقات',
         DASHBOARD: 'لوحة التحكم',
         REPORTS: 'التقارير',
         ACCOUNTS: 'الحسابات',
         ACCOUNT_OVERVIEW: 'نظرة عامة',
         ACCOUNT_SETTINGS: 'الإعدادات',
         ACCOUNT_EMPLOYEE: 'الموظف',
         ACCOUNT_COVENANTS: 'العهد',
         ACCOUNT_THEME: 'المظهر',
         ADMINISTRATOR: 'المسؤول',
         USER_MANAGEMENT: 'إدارة المستخدمين',
         USERS: 'المستخدمون',
         USERS_LIST: 'قائمة المستخدمين',
         ROLES: 'الأدوار',
         ROLES_LIST: 'قائمة الأدوار',
         PERMISSIONS: 'الصلاحيات',
         LOCATION: 'الموقع',
         LOCATION_MANAGEMENT: 'إدارة المواقع',
         COUNTRIES: 'الدول',
         COUNTRIES_LIST: 'قائمة الدول',
         STATES: 'المناطق',
         STATES_LIST: 'قائمة المناطق',
         HR_TEAM: 'فريق الموارد البشرية',
         COMPANY_MANAGEMENT: 'إدارة الشركة',
         COMPANIES: 'الشركات',
         VIEW_COMPANY: 'عرض الشركة',
         BRANCHES: 'الفروع',
         BRANCHES_LIST: 'قائمة الفروع',
         DEPARTMENT_MANAGEMENT: 'إدارة الأقسام',
         DEPARTMENTS_LIST: 'قائمة الأقسام',
         JOB_MANAGEMENT: 'إدارة الوظائف',
         JOBS_LIST: 'قائمة الوظائف',
         EMPLOYEE_MANAGEMENT: 'إدارة الموظفين',
         EMPLOYEES_LIST: 'قائمة الموظفين',
         IT_TEAM: 'فريق تقنية المعلومات',
         TICKET_MANAGEMENT: 'إدارة التذاكر',
         TICKETS: 'التذاكر',
         TICKETS_LIST: 'قائمة التذاكر',
         ASSIGNED_TICKETS: 'التذاكر المسندة',
         APPROVE_TICKETS: 'الموافقة على التذاكر',
         TYPES: 'الأنواع'
      },
      NAV_MENU: {
         MY_PROFILE: "ملفي الشخصي",
         ACCOUNT_SETTINGS: "إعدادات الحساب",
         SIGN_OUT: "تسجيل الخروج",
         LANGUAGE: "اللغة"
      },
      BRANCHES: {
         MAIN: "الفرع الرئيسي",
      },
      AUTH: {
         GENERAL: {
            OR: 'أو',
            SUBMIT_BUTTON: 'إرسال',
            NO_ACCOUNT: 'ليس لديك حساب؟',
            SIGNUP_BUTTON: 'تسجيل',
            FORGOT_BUTTON: 'نسيت كلمة المرور',
            BACK_BUTTON: 'رجوع',
            PRIVACY: 'الخصوصية',
            LEGAL: 'قانوني',
            CONTACT: 'اتصل بنا',
         },
         LOGIN: {
            TITLE: 'تسجيل الدخول',
            BUTTON: 'دخول',
         },
         FORGOT: {
            TITLE: 'نسيت كلمة المرور؟',
            DESC: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور',
            SUCCESS: 'تم إعادة تعيين حسابك بنجاح.'
         },
         REGISTER: {
            TITLE: 'تسجيل',
            DESC: 'أدخل بياناتك لإنشاء حسابك',
            SUCCESS: 'تم تسجيل حسابك بنجاح.'
         },
         INPUT: {
            EMAIL: 'البريد الإلكتروني',
            FULLNAME: 'الاسم الكامل',
            PASSWORD: 'كلمة المرور',
            CONFIRM_PASSWORD: 'تأكيد كلمة المرور',
            USERNAME: 'اسم المستخدم'
         },
         VALIDATION: {
            INVALID: '{{name}} غير صالح',
            REQUIRED: '{{name}} مطلوب',
            MIN_LENGTH: 'الحد الأدنى لطول {{name}} هو {{min}}',
            AGREEMENT_REQUIRED: 'قبول الشروط والأحكام مطلوب',
            NOT_FOUND: 'لم يتم العثور على {{name}} المطلوب',
            INVALID_LOGIN: 'تفاصيل تسجيل الدخول غير صحيحة',
            REQUIRED_FIELD: 'حقل مطلوب',
            MIN_LENGTH_FIELD: 'الحد الأدنى لطول الحقل:',
            MAX_LENGTH_FIELD: 'الحد الأقصى لطول الحقل:',
            INVALID_FIELD: 'الحقل غير صالح',
         }
      },
      ECOMMERCE: {
         COMMON: {
            SELECTED_RECORDS_COUNT: 'عدد السجلات المحددة: ',
            ALL: 'الكل',
            SUSPENDED: 'معلق',
            ACTIVE: 'نشط',
            FILTER: 'تصفية',
            BY_STATUS: 'حسب الحالة',
            BY_TYPE: 'حسب النوع',
            BUSINESS: 'شركة',
            INDIVIDUAL: 'فرد',
            SEARCH: 'بحث',
            IN_ALL_FIELDS: 'في جميع الحقول'
         },
         ECOMMERCE: 'التجارة الإلكترونية',
         CUSTOMERS: {
            CUSTOMERS: 'العملاء',
            CUSTOMERS_LIST: 'قائمة العملاء',
            NEW_CUSTOMER: 'عميل جديد',
            DELETE_CUSTOMER_SIMPLE: {
               TITLE: 'حذف العميل',
               DESCRIPTION: 'هل أنت متأكد من حذف هذا العميل نهائياً؟',
               WAIT_DESCRIPTION: 'جاري حذف العميل...',
               MESSAGE: 'تم حذف العميل'
            },
            DELETE_CUSTOMER_MULTY: {
               TITLE: 'حذف العملاء',
               DESCRIPTION: 'هل أنت متأكد من حذف العملاء المحددين نهائياً؟',
               WAIT_DESCRIPTION: 'جاري حذف العملاء...',
               MESSAGE: 'تم حذف العملاء المحددين'
            },
            UPDATE_STATUS: {
               TITLE: 'تم تحديث حالة العملاء المحددين',
               MESSAGE: 'تم تحديث حالة العملاء المحددين بنجاح'
            },
            EDIT: {
               UPDATE_MESSAGE: 'تم تحديث العميل',
               ADD_MESSAGE: 'تم إنشاء العميل'
            }
         }
      }
   }
};